import { readableColor } from "polished";

export const computeFontColor = color => {
  return readableColor(color);
};
